import { render, staticRenderFns } from "./InvoiceRecords.vue?vue&type=template&id=33680aae"
import script from "./InvoiceRecords.vue?vue&type=script&lang=js"
export * from "./InvoiceRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports